<template>
    <Transition name="pop">
        <div id="createPop" class="pop" v-if="state.create.show">
            <div class="content">
                <span class="close" @click="state.create.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>队伍创建</h1>
                <input
                    type="text"
                    v-model.trim="state.create.name"
                    placeholder="请填写您要创建的兄弟团名称"
                />
                <div class="btn-confirm" @click="confirmEvent">确认</div>
            </div>
        </div>
    </Transition>
    <Transition name="pop">
        <div id="confirmPop" class="pop" v-if="state.confirm.show">
            <div class="content">
                <span class="close" @click="state.confirm.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>确认创建</h1>
                <h3>
                    您确认创建<strong>{{ state.create.name }}</strong
                    >？
                </h3>
                <ul>
                    <li @click="cancelEvent">修改</li>
                    <li @click="submitEvent">确认</li>
                </ul>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive, inject } from "vue";
import { CreateTeam } from "@/api";

const getMyInfo = inject("getMyInfo");

const state = reactive({
    create: {
        show: false,
        name: ""
    },
    confirm: {
        show: false
    }
});

// 取消事件
const cancelEvent = () => {
    state.create.show = true;
    state.confirm.show = false;
};
// 确认事件
const confirmEvent = async () => {
    if (!state.create.name) {
        return CsGame.alert("请输入您要创建的兄弟团名称！", 1200, "error");
    }
    if (state.create.name.length > 8 || state.create.name.length < 2) {
        return CsLib.alert("兄弟会名称长度为2-8个字符！", 1200, "error");
    }
    state.confirm.show = true;
    state.create.show = false;
};

// 提交事件
const submitEvent = async () => {
    const res = await CreateTeam(state.create.name);
    if (res) {
        state.confirm.show = false;
        CsGame.alert(`${state.create.name}兄弟会创建成功！`, 1200, "success");
        getMyInfo();
    }
};

defineExpose({
    Show: () => {
        state.create.show = true;
    }
});
</script>

<style lang="scss" scoped>
#createPop {
    input {
        width: 360px;
        height: 46px;
        border: 1px solid #7c241e;
        margin: 0px auto;
        display: block;
        background: none;
        text-indent: 1em;
    }
    .btn-confirm {
        width: 240px;
        height: 50px;
        margin: 20px auto 10px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}
#confirmPop {
    .content {
        h3 {
            font-size: 18px;
            text-align: center;
            margin-bottom: 12px;
            display: flex;
            justify-content: center;
            strong {
                color: #3c8a67;
                font-weight: bold;
                margin: 0px 5px;
            }
        }
        ul {
            display: flex;
            justify-content: center;
            padding-top: 10px;
            li {
                width: 160px;
                text-align: center;
                line-height: 45px;
                height: 45px;
                margin: 0px 10px;
                border-radius: 6px;
                color: #fff;
                cursor: pointer;
                &:nth-of-type(1) {
                    background-color: #808080;
                }
                &:nth-of-type(2) {
                    background: linear-gradient(to bottom, #86362c, #d6584b);
                }
            }
        }
    }
}
</style>
